import TierGrid from './TierGrid';
export default TierGrid;
